// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_o2-5";
export var filledCircle = "_o2-4";
export var historyEntry = "_o2-3";
export var messageSideLeft = "_o2-1";
export var messageSideRight = "_o2-2";
export var orderTrackingCarouselWrapper = "_o2-6";
export var orderTrackingInfoContainer = "_o2-0";